import _ from "lodash";
import {
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  Pagination,
} from "@mui/material";
import { useEffect, useState } from "react";
import CustomTableHead from "./CustomTableHead";
import { Box } from "@mui/material";

function PaginatedTable({
  rows,
  columns,
  pagination = {},
  RowGetter,
  notRowsMessage,
  toRowOrderField,
  loading,
  defaultSortingFieldId,
  handleRequestSort = () => {},
  CardGetter,
}) {
  const { count, page, handleChangePage, rowsPerPage } = pagination;
  const [sortingField, setSortingField] = useState({
    direction: "desc",
    id: defaultSortingFieldId,
  });

  useEffect(() => {
    const offset = page * rowsPerPage;
    if (offset > count) handleChangePage(undefined, page - 1);
  }, [rowsPerPage, count, page]);

  function _handleRequestSort(event, property) {
    const id = property;
    let direction = "desc";

    if (sortingField.id === property && sortingField.direction === "desc") {
      direction = "asc";
    }
    const newSortField = { direction, id };
    setSortingField(newSortField);
    handleRequestSort(newSortField);
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "14rem",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (_.isEmpty(rows)) {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "5rem" }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
      >
        <Typography color="textSecondary" variant="h5">
          {notRowsMessage}
        </Typography>
      </Box>
    );
  }

  const orderedRows = _.orderBy(
    rows,
    [(row) => toRowOrderField(row, sortingField)],
    [sortingField.direction]
  );

  const start = page * rowsPerPage + 1;
  const end = Math.min((page + 1) * rowsPerPage, count);

  return (
    <Box sx={{ marginTop: "2rem" }}>
      <TableContainer sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
        <Table stickyHeader aria-labelledby="tableTitle">
          <CustomTableHead
            sortingField={sortingField}
            onRequestSort={_handleRequestSort}
            rows={columns}
          />
          <TableBody>
            {_.map(orderedRows, (row) => (
              <RowGetter key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
        {_.map(orderedRows, (row) => (
          <CardGetter key={row.id} row={row} />
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "center", md: "space-between" },
          mt: 3,
          mb: 3,
        }}
      >
        <Typography
          sx={{
            color: "grey.neutral",
            display: { xs: "none", sm: "none", md: "block" },
          }}
        >
          Mostrando datos de {start} a {end} de {count.toLocaleString()}{" "}
          entradas
        </Typography>

        <Pagination
          count={Math.ceil(count / rowsPerPage)}
          page={page + 1}
          onChange={(event, newPage) => handleChangePage(event, newPage - 1)}
          color="primary"
          sx={{
            "& .Mui-selected": {
              backgroundColor: "#3887BE",
              color: "#ffffff",
            },
            "& .MuiPaginationItem-root": {
              backgroundColor: "#EEEEEE",
              color: "#232533",
            },
            "& .MuiPaginationItem-ellipsis": {
              backgroundColor: "transparent",
              color: "#232533",
            },
          }}
        />
      </Box>
    </Box>
  );
}

export default PaginatedTable;
